// TastingBanner — subtle, persistent reminder shown while in Tasting Stage.
//
// Spec requirements it satisfies:
//   • subtle note: "Tasting Stage: your meals and preferences won't be saved
//     after you close this browser."
//   • NO "Logout" for guests — instead "Log in to save" and "Exit Tasting Stage".
//
// Presentational: onLogin / onExit are injected by NomLoop.

import React from "react";
import { DEFAULT_C } from "./authStyles.js";

export default function TastingBanner({ onLogin, onExit, C = DEFAULT_C }) {
  return (
    <div
      data-testid="tasting-banner"
      style={{
        // Sticky + solid so the note stays visible over the onboarding gradient
        // AND the planner, both of which render their own full-height screens.
        position: "sticky",
        top: 0,
        zIndex: 100,
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        padding: "8px 14px",
        background: "#FBEFD0",
        borderBottom: "1px solid #E7D6A8",
        fontSize: 13,
        color: C.charcoal,
        textAlign: "center",
      }}
    >
      <span style={{ opacity: 0.85 }}>
        <strong>Tasting Stage:</strong> your meals and preferences won’t be saved
        after you close this browser.
      </span>
      <span style={{ display: "inline-flex", gap: 8 }}>
        <button
          type="button"
          onClick={onLogin}
          data-testid="tasting-login"
          style={{
            border: "none",
            background: C.green,
            color: "#fff",
            fontWeight: 700,
            fontSize: 12.5,
            padding: "5px 12px",
            borderRadius: 8,
            cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          Log in to save
        </button>
        <button
          type="button"
          onClick={onExit}
          data-testid="tasting-exit"
          style={{
            border: "1px solid rgba(31,111,67,.4)",
            background: "transparent",
            color: C.greenDark,
            fontWeight: 600,
            fontSize: 12.5,
            padding: "5px 12px",
            borderRadius: 8,
            cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          Exit Tasting Stage
        </button>
      </span>
    </div>
  );
}
